var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertYellowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z",
    fill: "#FAC515",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13C2 6.92487 6.92487 2 13 2C19.0751 2 24 6.92487 24 13C24 19.0751 19.0751 24 13 24C6.92487 24 2 19.0751 2 13Z",
    fill: "#EAAA08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2508 11.5H13.7508V15.25H12.2508V11.5ZM12.25 16H13.75V17.5H12.25V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3257 7.15002C14.0647 6.65877 13.5562 6.35352 12.9997 6.35352C12.4432 6.35352 11.9347 6.65877 11.6737 7.15077L6.17022 17.548C6.04809 17.7763 5.9876 18.0326 5.9947 18.2914C6.0018 18.5502 6.07626 18.8027 6.21072 19.024C6.34324 19.2463 6.53145 19.4302 6.75675 19.5575C6.98206 19.6848 7.23668 19.7512 7.49547 19.75H18.504C19.035 19.75 19.5157 19.4785 19.7895 19.024C19.9237 18.8027 19.998 18.5502 20.0051 18.2914C20.0122 18.0326 19.9519 17.7764 19.83 17.548L14.3257 7.15002ZM7.49547 18.25L12.9997 7.85277L18.5077 18.25H7.49547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertYellowFilled);
export default __webpack_public_path__ + "static/media/alert_yellow_filled.fd3732351ab2c17975c0c3fbf26a38b9.svg";
export { ForwardRef as ReactComponent };